export const QUERY_KEYS = {
  ALERTS: 'Heartbeat/alerts',
  ALL_AGENTS_FLOWS: 'Heartbeat/allAgentsFlows',
  AGENTS: 'Heartbeat/agents',
  AGENTS_FLOWS: 'Heartbeat/agentsFlows',
  BEATBOXES: 'Heartbeat/beatboxes',
  BEATBOX_DEPLOYMENT: 'Heartbeat/beatboxDeployment/:deploymentId',
  CERTIFICATES: 'Heartbeat/certificates',
  DEPLOYED_FLOWS: 'Heartbeat/deployedFlows',
  ENDPOINTS: 'Heartbeat/endpoints',
  FLOW_ACCESSES: 'Heartbeat/flowAccesses',
  FLOW_ACCESSES_DISCREPANCIES_REPORT: 'Heartbeat/flowAccessesDiscrepanciesReport',
  FLOW_TOPOLOGY: 'Heartbeat/flowTopology',
  FLOW_TOPOLOGY_DETAIL: 'Heartbeat/flowTopologyDetail',
  FLOW_FAILURE_SUMMARY: 'Heartbeat/flowFailureSummary',
  FLOWS_FAILURE_SUMMARY: 'Heartbeat/flowsFailureSummary',
  HISTOGRAMS: 'Heartbeat/histograms',
  METRICS: 'Heartbeat/metrics',
  NON_MESSAGE_SPECIFIC: 'Heartbeat/secretsSpecification',
  ORGANIZATION_USERS: 'Heartbeat/organizationUsers',
  ORGANIZATION_USERS_ASSETS: 'Heartbeat/organizationUsersAssets',
  RESOURCE: 'Heartbeat/resource',
  OPENAPI_SPEC: 'Heartbeat/openApiSpec',
  RESOURCES: 'Heartbeat/resources',
  RESOURCE_TYPES: 'Heartbeat/resourceTypes',
  SECRETS: 'Heartbeat/secrets',
  SECRET_DETAILS: 'Heartbeat/secretDetails',
  SERVICE_ACCOUNTS: 'Heartbeat/serviceAccounts',
  DYNAMIC_TABLES: 'Heartbeat/dynamicTables',
  DYNAMIC_TABLES_ROWS: 'Heartbeat/dynamicTableRows',
  SERVICE_ACCOUNT_FLOW_ACCESS: 'Heartbeat/serviceAccountsFlowAccess',
  DOWNLOAD_TRACES: 'Heartbeat/downloadTraces',
  FLOW_TRACE: 'Heartbeat/flowTrace',
  FLOW_TRACES: 'Heartbeat/flowTraces',
  FLOW_SPEC_SCHEMA: 'Heartbeat/flowSpecSchema',
};
